import { c as _c } from "react/compiler-runtime";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useMaterialWarnings } from "@/queries/useMaterialWarnings";
interface Props {
  materialSku: string | undefined;
  marketingName: string;
}
export function MaterialWarning(t0) {
  const $ = _c(3);
  const {
    materialSku,
    marketingName
  } = t0;
  const {
    data: warnings
  } = useMaterialWarnings();
  const materialWarning = materialSku ? warnings?.materials[materialSku] : undefined;
  const warningText = warnings?.products[marketingName] ?? materialWarning;
  if (!warningText) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconAlertTriangle size={18} aria-hidden="true" className="shrink-0 text-amber-600" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== warningText) {
    t2 = <div className="mx-5 mt-3 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3">{t1}<p className="text-sm text-amber-800">{warningText}</p></div>;
    $[1] = warningText;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}